import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { goToMarketingSite } from '@/utility/marketingSite';

/**
 * Logged-out visitors at `/` go to the marketing site at www.wave.me (ROU-2032, marketing-site redirect).
 * Outside production there is no marketing site to send them to, so they go to
 * sign-in instead.
 */
const MarketingSiteRedirect = () => {
    useEffect(() => {
        if (import.meta.env.PROD) {
            goToMarketingSite();
        }
    }, []);

    return import.meta.env.PROD ? null : <Navigate to="/login" replace />;
};

export default MarketingSiteRedirect;
